import { MODEL_MANAGER_URL } from "../constants";
import apiService from "services/api";

export default {
  list: async () => apiService.get(`${MODEL_MANAGER_URL}/api/models`),
  voice: {
    list: async (payload) => {
      // TODO add search
      const { offset, limit, sortKey, sortDirection, filters, voiceTalent } =
        payload;
      const _filters = {
        locales: filters?.accents || [],
        visibility: filters?.type || [],
        species: filters?.species || [],
        gender: filters?.gender || [],
        age_group: filters?.age || [],
        pitch_group: filters?.pitch || [],
        nationality: filters?.nationality || [],
        narration_style_tag_groups: filters?.narrationStyle || [],
      };
      const searchParams = new URLSearchParams("");
      searchParams.append("offset", offset);
      searchParams.append("limit", limit);
      searchParams.append("sort", sortKey);
      searchParams.append("direction", sortDirection);
      Object.keys(_filters).forEach((key) => {
        if (_filters[key].length > 0) {
          _filters[key].forEach((f) => {
            searchParams.append(key, f);
          });
        }
      });
      // voice talent filter override
      if (voiceTalent === true || voiceTalent === false) {
        searchParams.append("voice_talent", voiceTalent);
      } else if (filters?.category && filters?.category.length === 1) {
        // this is a somewhat hacky solution to make the boolean
        // value of voice_talents work with the pagination filtering
        // logic
        searchParams.append(
          "voice_talent",
          (filters.category[0] === "voice_talent").toString()
        );
      }
      return apiService.get(
        `${MODEL_MANAGER_URL}/api/v2/voices?${searchParams.toString()}`
      );
    },
    favorite: async (payload) => {
      const { voiceId, flag } = payload;
      return apiService.post(
        `${MODEL_MANAGER_URL}/api/v2/voices/favorite/${voiceId}`,
        {
          body: JSON.stringify({
            favorite: flag,
          }),
        }
      );
    },
    search: async (payload) => {
      const { search: _search } = payload;
      const search = _search ? encodeURIComponent(_search) : undefined;
      return apiService.get(
        `${MODEL_MANAGER_URL}/api/v2/voices/search?name=${search}`
      );
    },
    byIds: async (payload) => {
      const voiceIds = payload;
      return apiService.post(`${MODEL_MANAGER_URL}/api/v2/voices/by-ids`, {
        body: JSON.stringify({
          voice_ids: voiceIds,
        }),
      });
    },
    updateSettings: async (payload) => {
      const { voiceId, semitonesCorrection, accentId, narrationStyleId } =
        payload;
      return apiService.post(`${MODEL_MANAGER_URL}/api/v2/voices/settings`, {
        body: JSON.stringify({
          voice_id: voiceId,
          accent_id: accentId,
          semitones_correction: semitonesCorrection,
          narration_style_id: narrationStyleId,
        }),
      });
    },
  },
  accent: {
    infos: async () =>
      apiService.get(`${MODEL_MANAGER_URL}/api/v2/accent-infos`),
  },
  demoSets: async () => apiService.get(`${MODEL_MANAGER_URL}/api/v2/demo-sets`),
  getNarrationStyleTags: async () =>
    apiService.get(`${MODEL_MANAGER_URL}/api/v2/narration-style-tags`),
  getNarrationStyleTagGroups: async () =>
    apiService.get(`${MODEL_MANAGER_URL}/api/v2/narration-style-tags/groups`),
};
